import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {EditPermissions} from '../../../../../../../../../shared/models';
import {isNumber, maximumCount, required} from '../../../../../../../../../shared/utils';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { InputValidatorsComponent } from '../../../../templates/input-validators/input-validators.component';
import { MatSelect, MatOption } from '@angular/material/select';
import { CMSComponent } from '../../../../../../../../../shared/components/cms/cms.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';

interface InputPage {
  pageType: 'inputPage';
  order?: number;
  pageHeader: string;
  pageSubHeader: string;
  regex: string;
  placeHolder: string;
  inputType: 'multiline' | 'singleline';
  labelText: string;
  prefixText: string;
  maximumCharacterCount: number;
  keyboardType: string;
  required: boolean;
}

@Component({
    selector: 'input-page',
    templateUrl: './input-page.component.html',
    styleUrls: ['../styles.scss', './input-page.component.scss'],
    imports: [NgTemplateOutlet, NgClass, ReactiveFormsModule, InputValidatorsComponent, MatSelect, MatOption, CMSComponent, MatSlideToggle]
})
export class InputPageComponent implements OnInit, OnDestroy {
  constructor() {}

  @Input() pageData: any;
  @Input() canEdit: EditPermissions;
  @Output() setPageData = new EventEmitter();
  moreInfoOpened = false;

  inputPageForm: UntypedFormGroup;

  ngOnInit() {
    this.inputPageForm = this.getInputPageTemplate();

    const { page, newPage } = this.pageData;
    this.inputPageForm.patchValue(page);

    if (newPage === false) {
      this.inputPageForm.markAllAsTouched();
    }

    this.setPageDataHandler();
    this.listenForFormChanges();
  }

  ngOnDestroy() {
    this.setPageDataHandler();
  }

  getInputPageTemplate() {
    return new UntypedFormGroup({
      pageHeader: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }),
      pageSubHeader: new UntypedFormControl({
            value: '',
            disabled: !this.canEdit
          }, [required('Subheader')]),
      regex: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }),
      placeHolder: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }, [required('Placeholder')]),
      inputType: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }),
      labelText: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }),
      prefixText: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }),
      maximumCharacterCount: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }, [maximumCount(300, 'Character count'), isNumber('maximumCharacterCount')]),
      keyboardType: new UntypedFormControl({
        value: '',
        disabled: !this.canEdit
      }),
      required: new UntypedFormControl({
        value: false,
        disabled: !this.canEdit
      })
    });
  }

  setPageDataHandler() {
    const data = {
      ...this.pageData,
      page: this.getData()
    };
    this.setPageData.emit(data);
  }

  listenForFormChanges() {
    this.inputPageForm.valueChanges.subscribe(values => {
      this.setPageDataHandler();
    });
  }

  getData() {
    const pageFormValues = this.inputPageForm.getRawValue();
    return {
      ...pageFormValues,
      pageType: this.pageData.type,
      valid: this.inputPageForm.valid
    };
  }

  openMoreInfo() {
    this.moreInfoOpened = true;
  }

  closeMoreInfo() {
    this.moreInfoOpened = false;
  }
}
